module.exports = __webpack_public_path__ + "media/images/admin/icons/git-commit-ba691415c8d94f638dd9e29320b6f198.svg";